module.exports = __webpack_public_path__ + "img/top_dh@2x.7e97a447.png";